<template>
	<div class="keyword">
		<div class="hero">
			<img src="../assets/img/keyword/title.svg" alt="クレハがわかる！7のキーワード" />
		</div>
		<div class="contents">
			<div class="introduction">
				1944年の創立以来、<br class="under" />「ナケレバ、ツクレバ。」の精神で、<br />
				様々な領域において先進的な開発を続けてきた私たち。<br class="under" />これまで生み出してきたモノから<br />
				社員の働き方まで、このページを読めば<br class="under" />クレハの魅力が丸わかり！
			</div>
			<div class="block-set">
				<a
					:class="['block', `block0${index + 1}`]"
					@click="openModal(index)"
					v-for="(content, index) in modalContents"
					v-bind:key="`block${index}`"
				>
					<h3 class="block-title">
						<img :src="require(`../assets/img/keyword/number0${index + 1}.svg`)" :alt="index + 1" />
						<i v-html="content.title"></i>
					</h3>
					<div class="block-image">
						<img :src="require(`../assets/img/keyword/image0${index + 1}.jpg`)" :alt="content.title" />
					</div>
				</a>
			</div>
		</div>
		<MyModal @close="closeModal" v-if="modal">
			<div :class="`modal-content${contentsNum + 1}`">
				<!-- default スロットコンテンツ -->
				<h3 class="modal-title">
					<img :src="require(`../assets/img/keyword/number0${contentsNum + 1}.svg`)" :alt="contentsNum + 1" />
					<i v-html="modalContents[contentsNum].title"></i>
				</h3>
				<div class="modal-inner">
					<div class="modal-image">
						<img
							:src="require(`../assets/img/keyword/modal/image0${contentsNum + 1}.jpg`)"
							:alt="modalContents[contentsNum].title"
						/>
					</div>
					<div class="modal-comment">
						{{ modalContents[contentsNum].comment }}
					</div>
					<div class="modal-url_none" :class="modalContents[contentsNum].urlClass">
						<a :href="modalContents[contentsNum].urlLink" target="_blank"
							>{{ modalContents[contentsNum].urlText }}
							<IconBase :width="15" iconColor="#008000" class="icon_base"><Blank /></IconBase>
						</a>
						<KurehaArrow class="kureha_arrow" :width="1000" />
					</div>
				</div>
			</div>
		</MyModal>
	</div>
</template>
<script>
import MyModal from '@/components/MyModal.vue';
import IconBase from '@/components/IconBase.vue';
import KurehaArrow from '@/components/icons/KurehaArrow.vue';
import Blank from '@/components/icons/Blank.vue';
export default {
	name: 'keyword',
	components: {
		MyModal,
		KurehaArrow,
		IconBase,
		Blank,
	},
	data() {
		return {
			modal: false,
			contentsNum: '',
			photoElement: '',
			modalContents: [
				{
					title: 'ナケレバ、ツクレバ。',
					comment:
						'自社開発への強いこだわりを持つクレハのDNA。現在、クレハで販売しているほとんどの製品が自社開発により生み出されたものです。そのDNAの原点となっているのが塩化ビニリデン樹脂の開発。ロングセラー商品「クレハロンフィルム」や「NEWクレラップ」もこの開発の成果として生み出されました。どこにも無ければ、創ればいい。「ナケレバ、ツクレバ。」の精神で、自社開発にこだわったものづくりを続けています。',
				},
				{
					title: '広がる海外拠点',
					comment:
						'海外にも着実に市場を広げるクレハ。高機能材や食品包装材、医薬・農薬など、スペシャリティの高いものが世界で求められています。マーケットの広がりに伴って海外での生産も拡大。現在、アメリカ、ヨーロッパ、アジア、オセアニアの各地域に拠点を有し、海外市場の積極的な拡大を進めています。',
				},
				{
					title: 'ワーク<br>ライフバランス',
					comment:
						'クレハでは、従業員が仕事と家庭や子育て・介護などの仕事以外の生活と調和を保ちながら、活き活きと働けるように各種制度（育児休業、介護休業、リフレッシュ制度、時間単位年次有給休暇制度など）を導入しています。また、働き方改革として、年次有給休暇取得率の向上、時間外勤務の削減を目指しています。',
					urlClass: 'modal-url',
					urlLink: 'https://www.kureha.co.jp/csr/social/staff/',
					urlText: 'クレハの従業員に対する\n取り組みについて、詳しくはこちら',
				},
				{
					title: '少数精鋭',
					comment:
						'一人ひとりの技術力や提案力を重視しているからこそ、年齢や役職に関係なく、やりたいことにチャレンジできる環境です。自らの仕事に誇りと責任を持ち、「まだないものをつくって世の中に貢献する」という思いで仕事に取り組んでいます。',
				},
				{
					title: 'さらなる<br>成長と挑戦',
					comment:
						'クレハは、1944年の創立以来培ってきた独創的な技術力をベースに、常に挑戦することで成長を遂げてきました。これからも、独創的なアイデアと、技術力に磨きをかけ、社会に貢献し続ける高付加価値型企業として、将来の発展に向けた土台づくりを進めていきます。',
				},
				{
					title: '論文審査制度',
					comment:
						'当社では1959年より若手技術者を対象に論文審査制度を導入しています。研究成果の「発表・提案・審査」を通して成長する場として、クレハの文化になっており、挑戦する風土を構築してきました。本制度を通じて、多くの技術者が成長し、クレハの技術力向上に貢献しています。2016年度からは企画・営業職種へも対象を拡大し実施しています。',
				},
				{
					title: '充実した<br>育成制度',
					comment:
						'社員の挑戦意欲と自己実現をサポートするため、クレハでは手厚い人財育成制度を設けています。職系・職種ごとの研修や現場でのOJTの他、デジタルマインド底上げ・スペシャリスト育成のためのデジタル人財育成や、オンライン英会話研修等の提供によるグローバル人財育成にも力を入れています。また、キャリア面談等の従業員がキャリア意識をもって成長することを支援する制度や、主体的・自律的なスキルアップを目的とした応募型研修等を提供しています。更に、技術立社として成長し続けるため、技術系人財の継続的な育成を図るべく、さまざまなプログラムを用意しています。',
					urlClass: 'modal-url',
					urlLink: 'https://www.kureha.co.jp/csr/social/staff/training.html',
					urlText: 'クレハの人財育成に対する\n取り組みについて、詳しくはこちら',
				},
			],
		};
	},
	methods: {
		openModal(el) {
			this.modal = true;
			this.contentsNum = el;
		},
		closeModal() {
			this.modal = false;
		},
	},
};
</script>

<style scoped lang="scss">
.hero {
	height: 500px;
	background: linear-gradient(to right, #3fae00, #00797f);
	position: relative;
	@media print, screen and (max-width: 414px) {
		height: 250px;
	}
	&:after {
		content: '';
		width: 0;
		height: 0;
		border: 30px solid transparent;
		border-top: 30px solid #249451;
		bottom: -60px;
		position: absolute;
		left: 0;
		right: 0;
		margin: auto;
		@media print, screen and (max-width: 414px) {
			border: 20px solid transparent;
			border-top: 20px solid #249451;
			bottom: -40px;
		}
	}
	img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		margin: 0;
		max-width: 340px;
		width: 100%;
		@media print, screen and (max-width: 414px) {
			width: 45%;
		}
	}
}
.contents {
	max-width: 1200px;
	margin: 0 auto;
	padding: 100px 0;
	@media print, screen and (max-width: 1200px) {
		padding: 50px 0;
	}
}
.introduction {
	font-weight: bold;
	font-size: 20px;
	text-align: center;
	color: #00797f;
	margin: 0 auto;
	@media print, screen and (max-width: 1200px) {
		font-size: 13px;
		width: 90%;
	}
	br.under {
		@media print, screen and (min-width: 1201px) {
			display: none;
		}
	}
}
.block-set {
	margin: 0 auto;
	margin-top: 100px;
	display: grid;
	display: -ms-grid;
	grid-template-rows: 390px 390px 390px 390px;
	-ms-grid-rows: 390px 390px 390px 390px;
	grid-template-columns: 390px 390px 380px;
	-ms-grid-columns: 390px 390px 380px;
	grid-gap: 20px;
	width: 100%;
	@media print, screen and (max-width: 1200px) {
		// grid-template-rows: 650px 320px 320px 320px 320px;
		// grid-template-columns: 320px 320px;
		grid-template-rows:
			calc(90vw - 5px) calc(45vw - 5px) calc(45vw - 5px) calc(45vw - 5px)
			calc(45vw - 5px);
		-ms-grid-rows: calc(90vw - 5px) calc(45vw - 5px) calc(45vw - 5px) calc(45vw - 5px) calc(45vw - 5px);
		grid-template-columns: calc(45vw - 5px) calc(45vw - 5px);
		-ms-grid-columns: calc(45vw - 5px) calc(45vw - 5px);
		width: 90%;
		grid-gap: 10px;
		margin-top: 50px;
	}
}
.block {
	position: relative;
	cursor: pointer;
	overflow: hidden;
	display: block;
}
.block01 {
	grid-row: 1 / 3;
	grid-column: 1 / 3;
	-ms-grid-row: 1;
	-ms-grid-column: 1;
	-ms-grid-row-span: 2;
	-ms-grid-column-span: 2;
	@media print, screen and (max-width: 1200px) {
		grid-row: 1 / 2;
		grid-column: 1 / 3;
		-ms-grid-row: 1;
		-ms-grid-column: 1;
		-ms-grid-column-span: 2;
	}
	.block-title {
		background-color: #809f00;
		&:after {
			border-top: 20px solid #809f00;
		}
	}
}
.block02 {
	grid-row: 1 / 2;
	grid-column: 3 / 4;
	-ms-grid-row: 1;
	-ms-grid-column: 3;
	@media print, screen and (max-width: 1200px) {
		grid-row: 2 / 3;
		grid-column: 1 / 2;
		-ms-grid-row: 2;
		-ms-grid-column: 1;
	}
	.block-title {
		background-color: #3f9900;
		&:after {
			border-top: 20px solid #3f9900;
		}
	}
}
.block03 {
	grid-row: 2 / 3;
	grid-column: 3 / 4;
	-ms-grid-row: 2;
	-ms-grid-column: 3;
	@media print, screen and (max-width: 1200px) {
		grid-row: 2 / 3;
		grid-column: 2 / 3;
		-ms-grid-row: 2;
		-ms-grid-column: 2;
	}
	.block-title {
		background-color: #008000;
		&:after {
			border-top: 20px solid #008000;
		}
	}
}
.block04 {
	grid-row: 3 / 4;
	grid-column: 1 / 3;
	-ms-grid-row: 3;
	-ms-grid-column: 1;
	-ms-grid-column-span: 2;
	@media print, screen and (max-width: 1200px) {
		grid-row: 3 / 4;
		grid-column: 1 / 3;
		-ms-grid-row: 3;
		-ms-grid-column: 1;
		-ms-grid-column-span: 2;
	}
	.block-title {
		background-color: #0097a7;
		&:after {
			border-top: 20px solid #0097a7;
		}
	}
}
.block05 {
	grid-row: 3 / 5;
	grid-column: 3 / 4;
	-ms-grid-row: 3;
	-ms-grid-column: 3;
	-ms-grid-row-span: 2;
	@media print, screen and (max-width: 1200px) {
		grid-row: 4 / 6;
		grid-column: 1 / 2;
		-ms-grid-row: 4;
		-ms-grid-column: 1;
		-ms-grid-row-span: 2;
	}
	.block-title {
		background-color: #008d81;
		&:after {
			border-top: 20px solid #008d81;
		}
	}
}
.block06 {
	grid-row: 4 / 5;
	grid-column: 1 / 2;
	-ms-grid-row: 4;
	-ms-grid-column: 1;
	@media print, screen and (max-width: 1200px) {
		grid-row: 4 / 5;
		grid-column: 2 / 3;
		-ms-grid-row: 4;
		-ms-grid-column: 2;
	}
	.block-title {
		background-color: #00797f;
		&:after {
			border-top: 20px solid #00797f;
		}
	}
}
.block07 {
	grid-row: 4 / 5;
	grid-column: 2 / 3;
	-ms-grid-row: 4;
	-ms-grid-column: 2;
	@media print, screen and (max-width: 1200px) {
		grid-row: 5 / 6;
		grid-column: 2 / 3;
		-ms-grid-row: 5;
		-ms-grid-column: 2;
	}
	.block-title {
		background-color: #005473;
		&:after {
			border-top: 20px solid #005473;
		}
	}
}
.block-title {
	position: absolute;
	top: 0;
	background-color: #000;
	width: calc(100% - 40px);
	margin: 0;
	padding: 0 20px;
	color: #fff;
	display: flex;
	align-items: center;
	height: 100px;
	z-index: 0;
	line-height: 1.5em;
	@media print, screen and (max-width: 414px) {
		font-size: 13px;
		padding: 0 10px;
		width: calc(100% - 20px);
		height: 50px;
	}
	&:after {
		content: '';
		width: 0;
		height: 0;
		border: 20px solid transparent;
		border-top: 20px solid #000;
		position: absolute;
		bottom: -40px;
		left: 30px;
		@media print, screen and (max-width: 414px) {
			bottom: -30px;
			left: 20px;
			z-index: -1;
		}
	}
	i {
		::v-deep br {
			@media print, screen and (min-width: 414px) {
				display: none;
			}
		}
	}
	img {
		height: 2em;
		vertical-align: middle;
		margin: 0px 20px;
		@media print, screen and (max-width: 414px) {
			height: 1.5em;
			margin: 0px 10px;
		}
	}
}
.block-image {
	img {
		// vertical-align: text-top;
		vertical-align: top;
	}
}
::v-deep .close_button_inner {
	background-image: url('../assets/img/keyword/close.svg');
}
.modal-title {
	margin: 0;
	width: calc(100% - 40px);
	left: 0;
	top: 0;
	background-color: #000;
	position: relative;
	color: #fff;
	padding: 20px;
	@media print, screen and (max-width: 1200px) {
		font-size: 13px;
		padding: 10px;
		width: calc(100% - 20px);
	}
	&:after {
		content: '';
		width: 0;
		height: 0;
		border: 20px solid transparent;
		border-top: 20px solid #000;
		position: absolute;
		bottom: -40px;
		left: 50px;
		@media print, screen and (max-width: 1200px) {
			bottom: -30px;
			left: 20px;
		}
	}
	img {
		height: 2em;
		vertical-align: middle;
		margin: 0px 20px;
		@media print, screen and (max-width: 1200px) {
			height: 1.5em;
			margin: 0px 10px;
		}
	}
	::v-deep br {
		display: none;
	}
}
.modal-content1 {
	.modal-title {
		background-color: #809f00;
		&:after {
			border-top: 20px solid #809f00;
		}
	}
}
.modal-content2 {
	.modal-title {
		background-color: #3f9900;
		&:after {
			border-top: 20px solid #3f9900;
		}
	}
}
.modal-content3 {
	.modal-title {
		background-color: #008000;
		&:after {
			border-top: 20px solid #008000;
		}
	}
}
.modal-content4 {
	.modal-title {
		background-color: #0097a7;
		&:after {
			border-top: 20px solid #0097a7;
		}
	}
}
.modal-content5 {
	.modal-title {
		background-color: #008d81;
		&:after {
			border-top: 20px solid #008d81;
		}
	}
}
.modal-content6 {
	.modal-title {
		background-color: #00797f;
		&:after {
			border-top: 20px solid #00797f;
		}
	}
}
.modal-content7 {
	.modal-title {
		background-color: #005473;
		&:after {
			border-top: 20px solid #005473;
		}
	}
}
.modal-inner {
	width: 90%;
	margin: 0 auto;
	padding: 30px 0;
}
.modal-image {
	margin-top: 50px;
	@media print, screen and (max-width: 1200px) {
		margin-top: 20px;
	}
}
.modal-comment {
	font-weight: bold;
	margin-top: 20px;
	@media print, screen and (max-width: 1200px) {
		font-size: 12px;
	}
}
@media all and (-ms-high-contrast: none) {
	.block04 .block-image {
		width: calc(100% + 20px);
	}
}

.modal-url_none {
	display: none;
}
.modal-url {
	margin-top: 10px;
	display: inline-block;
	position: relative;
	color: #008000;
	font-weight: bold;
	font-size: 16px;
	white-space: nowrap;
	@media print, screen and (max-width: 767px) {
		white-space: pre-wrap;
		font-size: 12px;
	}
	.kureha_arrow {
		width: 102%;
		max-width: 102%;
		bottom: -18%;
		@media print, screen and (max-width: 414px) {
			width: 81vw;
			bottom: -10%;
		}
	}
	@media print, screen and (max-width: 414px) {
		.icon_base {
			position: absolute;
			left: 75vw;
			bottom: 5px;
		}
	}
}

@media print, screen and (min-width: 415px) {
	.sp_only {
		display: none;
	}
}
</style>
